import React from 'react'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  isHotelItem?: boolean
  hotelName?: string
  size?: 'small' | 'medium' | 'large'
  colour?: App.Design.ContentColour
}

function HotelInclusionLabel({
  hotelName,
  isHotelItem = false,
  size = 'small',
  colour = 'highlight-secondary'
}: Props) {
  const label = isHotelItem ? 'Hotel inclusions applied' : `Included with your${hotelName ? ` ${hotelName}` : ''} stay`
  return (
    <BodyTextBlock
      variant={size}
      colour={colour}
      data-testid="hotel-inclusion-label"
    >
      {label}
    </BodyTextBlock>
  )
}

export default React.memo(HotelInclusionLabel)
